<template>
<v-container fluid>
  <v-card>
    <v-col cols="12" sm="6" md="3">
      Trains Report {{$route.query.crew_id}}
    </v-col>
    <v-row class="mx-auto">
      <v-col v-for="(value, name) in summary">
        <v-chip :color="getSummaryColour(name)" dark>{{name}} : {{value}}</v-chip>
      </v-col>
    </v-row>
    <v-card-title>
      <v-row>
        <v-col cols="12" sm="6" md="2">
          <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y full-width max-width="400px" min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="train_date" required :rules="dateRules" prepend-icon="event" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="train_date" no-title @input="initialize(false)"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <div class="text-center">
            <v-btn rounded color="primary" dark @click="initialize(true)">Calc. All</v-btn>
          </div>
        </v-col>
        <v-col cols="12" sm="6" md="1">
          <div class="text-center">
            <v-btn rounded color="primary" dark @click="(not_detected = !not_detected);initialize(false)">!Detected</v-btn>
          </div>
        </v-col>
        <v-col cols="12" sm="6" md="1">
          <div class="text-center">
            <v-btn rounded color="primary" dark @click="(not_auto_attached = !not_auto_attached);initialize(false)">!Attached</v-btn>
          </div>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <div class="text-center subtitle-2">
            <span v-if="msg.calcStartedAt"> Calc Started: {{getFormattedTime(msg.calcStartedAt)}} </span> <span v-if="msg.calcCompletedAt">ended: {{getFormattedTime(msg.calcCompletedAt)}} </span>
          </div>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <div class="text-center">
            <v-btn rounded color="primary" dark @click="exportToexcel()">Excel</v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card-title>
    <v-data-table :headers="headers" :items="trains" :search="search" item-key="train_date+ train_no+name" :footer-props="{
    'items-per-page-options': [10, 20, 30, 40, 50, 100,900]
    }" :items-per-page="40" sort-by="trains" class="elevation-1" @click:row="onRowClick($event)"
     :loading="isLoading" loading-text="Loading... Please wait" :mobile-breakpoint="100">
     <template v-slot:item.id="{ item }">
       {{trains.map(function(x) {
     return x.id;
     }).indexOf(item.id)+1}}
     </template>
      <template v-slot:item.train_date="{ item }">
        {{getFormattedDate(item.train_date)}}
      </template>
      <template v-slot:item.act_dep="{ item }">
        {{getFormattedTime(item.act_dep)}}
      </template>
      <template v-slot:item.dep="{ item }">
        {{getFormattedTime(item.dep)}}
      </template>
      <template v-slot:item.arr="{ item }">
        {{getFormattedTime(item.arr)}}
      </template>
      <template v-slot:item.act_arr="{ item }">
        {{getFormattedTime(item.act_arr)}}</v-chip>
      </template>
      <template v-slot:item.late_dep="{ item }">
        {{getFormattedTimeSec(item.late_dep)}}
      </template>
      <template v-slot:item.late_arr="{ item }">
        <v-chip :color="getColour(item)" dark>{{getFormattedTimeSec(item.late_arr)}}</v-chip>
      </template>
      <template v-slot:item.act_arr_pf="{ item }">
        {{getFormattedTime(item.act_arr_pf)}}</v-chip>
      </template>

      <template  v-slot:item.act_arr="props" v-slot:click.native.stop="true">
        <v-edit-dialog v-if="!props.item.act_arrr" :return-value.sync="props.item.act_arr" large @save="saveActArr(props.item)" @open="openEditActArr(props.item.act_arr)" @close="closeEditActArr"> {{getFormattedTime(props.item.act_arr)}}
          <template v-slot:input>
            <v-datetime-picker ref="editActArr" label="Select Arrival time" :disabled="props.item.act_arr != null"
             :text-field-props="textFieldProps"
             :date-picker-props="dateProps"
             :time-picker-props="timeProps"
             date-format="yyyy-MM-dd"
             time-format="HH:mm:ss"
             v-model="act_arr_formatted">
            </v-datetime-picker>
          </template>
        </v-edit-dialog>
      </template>

      <!-- <template v-slot:item.failure_report="props" v-slot:click.native.stop="true">Rake Failure
        <v-edit-dialog :return-value.sync="props.item.failure_report" large @save="saveRakeFailure(props.item)" @cancel="cancelRakeFailure" @open="openRakeFailure" @close="closeRakeFailure"> {{( props.item.failure_report ? props.item.failure_report.substring(0,6): null) }}
          <template v-slot:input>
            <v-textarea ref="rakeFailure" v-model="props.item.failure_report" label="Report" single-line autofocus counter></v-textarea>
          </template>
        </v-edit-dialog>
      </template> -->
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize(true)">No Report, click to retry</v-btn>
      </template>
    </v-data-table>
  </v-card>
</v-container>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import _ from 'lodash'
import {
  mapState,
  mapGetter,
  mapActions
} from 'vuex'
import jsonexport from 'jsonexport/dist'
import {
  saveAs
} from 'file-saver';

export default {
  name: 'TrainsReport',
  data() {
    return {
      search: '',
      valid: false,
      dateRules: [v => !!v || 'Date is required'],
      errors: [],
      headers: [
        {
            text: 'Srl',
            align: 'left',
            sortable: true,
            value: 'id',

        },
        {
          text: 'Train Date',
          align: 'left',
          sortable: true,
          value: 'train_date',
        },
        {
          text: 'Train No',
          align: 'left',
          sortable: true,
          value: 'train_no',
        },
        {
          text: 'Rake No',
          align: 'left',
          sortable: true,
          value: 'device_name',
        },
        {
          text: 'ORG',
          value: 'org'
        },
        {
          text: 'Sch Dep.',
          value: 'dep'
        },
        {
          text: 'Act Dep.',
          value: 'act_dep'
        },
        {
          text: 'Late Dep.',
          value: 'late_dep',
          sortable: true
        },
        {
          text: 'DEST',
          value: 'dest'
        },
        {
          text: 'Sch Arr.',
          value: 'arr'
        },
        {
          text: 'Act Arr.',
          value: 'act_arr'
        },
        {
          text: 'Late Arr.',
          value: 'late_arr',
          sortable: true
        },
        {
          text: 'M/PF',
          value: 'pf',
          sortable: true
        },
        {
          text: 'A/A',
          value: 'auto_attach',
          sortable: true
        },
        {
          text: 'A/PF',
          value: 'guess_pf',
          sortable: true
        },
        {
          text: 'A/Arr',
          value: 'act_arr_pf',
          sortable: true
        },
        {
          text: 'GPS PF',
          value: 'gps_pf',
          sortable: true
        },
        // { text: 'Report', value: 'failure_report', sortable: true },
      ],
      train: {},
      train_loading: false,
      trains: [],
      train_date: this.curTrainDate || moment().format('YYYY-MM-DD'),
      menu1: false,
      menu2: false,
      isLoading: false,
      not_detected: false,
      not_auto_attached: false,
      summary: {},
      act_arr_formatted: null,
      textFieldProps: {
       appendIcon: 'event'
     },
     dateProps: {
       headerColor: 'red'
     },
     timeProps: {
       useSeconds: true,
       format: '24hr'
     },
     snack: false,
     snackColor: '',
     snackText: '',
    }
  },
  computed: {
    ...mapState(['curDeviceId', 'curDeviceName', 'curTrainNo', 'curTrainDate', 'curOrg', 'curArr', 'curDest', 'curDep','curCrewId',
     'actDep', 'actArr','curStartDate','curEndDate','msg']),
  },
  created() {
    this.train_date= this.curTrainDate || moment().format('YYYY-MM-DD'),
    this.initialize(false)
    setInterval(() => {
      if (this.msg.calcualtingAllCTR) {
         this.checkCalcProgress()
      }
    }, 10000);
  },
  methods: {
    ...mapActions(['updateCurDeviceId', 'updateCurDeviceName', 'updateCurTrainNo', 'updateCurTrainDate', 'updateCurOrg', 'updateCurCrewId',
     'updateCurArr', 'updateCurDest', 'updateCurDep', 'updateActDep', 'updateActArr','updateCurStartDate','updateCurEndDate','updateCTRmsg']),
    initialize(calcall) {
      this.menu1 = false
      // console.log(this.train_date)
      // console.log(this.curTrainDate)
      this.updateCurTrainDate(moment(this.train_date).format("YYYY-MM-DD"))
        // console.log(this.curTrainDate)
      //      console.log(this.curDeviceId)
      this.isLoading = true

      var p = {
        train_date: this.curTrainDate,
        calcall: calcall,
        start_date: this.$route.query.start_date,
        end_date: this.$route.query.end_date,
        crew_id: this.$route.query.crew_id,
        train_no: this.$route.query.train_no,
        device_id: this.$route.query.device_id,
        device_name: this.$route.query.device_name,
        org: this.curOrg,
        dest: this.curDest,
        not_detected: this.not_detected ? true : null,
        not_auto_attached: this.not_auto_attached ? true : null
      }
      // console.log(p)
      var endPoint = 'reportforperiod'
      if (calcall) {
        endPoint = 'recalctrainreport'
      }
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios.get(`${process.env.VUE_APP_API_URL}/train/tr/${endPoint}`, {
          params: p
        })
        .then(response => {
          // console.log(response);
          this.isLoading = false
          if (calcall) {
             this.updateCTRmsg(response.data.msg)
              console.log(this.msg)
          } else {
            this.trains = []
            this.trains = response.data
            var rakewise_trains =_.sortBy( _.groupBy(response.data, 'device_name'), 'dep')
            // console.log(rakewise_trains)
            this.summary = this.getSummary(response.data)
          }
        })
        .catch(e => {
          console.log(e)
          this.isLoading = false
        })
    },
    saveRakeFailure(item) {
      var p = {
        id: item.id,
        rake_failure: item.rake_failure
      }
      // console.log(p)
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios.post(`${process.env.VUE_APP_API_URL}/train/update_rake_failure/`, p)
        .then(res => {
          item.rake_failure = p.rake_failure
          this.snackColor = 'success'
          this.snackText = res.data.msg
          this.snack = true
          // console.log(res)
        })
        .catch(err => {
          this.snackColor = 'error'
          this.snackText = err
          this.snack = true
          console.log(err)
        })
    },
    cancelRakeFailure(item) {

    },
    openRakeFailure(item) {

    },
    closeRakeFailure(item) {

    },
    checkCalcProgress() {
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios.get(`${process.env.VUE_APP_API_URL}/train/tr/check_status_calc_all_ctr`)
        .then(response => {
          // console.log(response);
            this.updateCTRmsg(response.data.msg)
            console.log(this.msg)
        })
        .catch(e => {
          console.log(e)
        })
    },
    round(value, precision) {
      var multiplier = Math.pow(10, precision || 0);
      return Math.round(value * multiplier) / multiplier;
    },
    exportToexcel() {
      let csvContent = "data:text/csv;charset=utf-8,";
      var filename = this.curTrainDate + '- punctuality' + '.csv'
      var trains1 =[]
      this.trains.forEach((item, i) => {
        trains1.push({
            'Train No': item.train_no,
            'Rake No': item.device_name,
            'Org': item.org,
            'Sch Dep': this.getFormattedTime(item.dep),
            'Act Dep': this.getFormattedTime(item.act_dep),
            'Late Dep': this.getFormattedTimeSec(item.late_dep),
            'Dest': item.dest,
            'Sch Arr': this.getFormattedTime(item.arr),
            'Act Arr': this.getFormattedTime(item.act_arr),
            'Late Arr': this.round(item.late_arr/60, 0)
          }
         )
      });
      // console.log(trains1)
      var trains2 = _.filter(trains1, function(o) { return o['Late Arr'] > 5; });
      // console.log(trains2)
      jsonexport(trains2, function(err, csv) {
        if (err) return console.log(err);
        //console.log(csv);
        var blob = new Blob([csv], {
          type: "data:text/csv;charset=utf-8,"
        });
        saveAs(blob, filename);
      });
    },
    openEditActArr(act_arr) {
      if (act_arr != null){
          this.act_arr_formatted = moment.utc(act_arr).format("YYYY-MM-DD HH:mm:ss")
      } else {
        this.act_arr_formatted = moment().format("YYYY-MM-DD HH:mm:ss")
      }
    },
    closeEditActArr() {

    },
    saveActArr(item) {
      // console.log(this.act_arr_formatted)
      var p = {
        id: item.id,
        stn_code: item.stn_code,
        sch_arr: item.arr,
        act_arr: this.act_arr_formatted == null  ? null: moment(this.act_arr_formatted).format("YYYY-MM-DD HH:mm:ss")
      }
      // console.log(p)
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios.post(`${process.env.VUE_APP_API_URL}/train/update_act_arr/`, p)
        .then(res => {
          item.act_arr = p.act_arr
          this.snackColor = 'success'
          this.snackText = res.data.msg
          this.snack = true
          // console.log(res)
        })
        .catch(err => {
          this.snackColor = 'error'
          this.snackText = err
          this.snack = true
          console.log(err)
        })
    },
    //update traccar_db.device_train_map set dep = addtime(train_date, time(dep)), arr = addtime(train_date, time(arr));
    //update traccar_db.device_train_map set arr = adddate(arr, 1) where arr < dep;
    onRowClick($event) {
      //       console.log($event);
      // this.updateCurTrainNo($event.train_no)
      this.updateCurTrainDate(moment($event.train_date).format("YYYY-MM-DD"))
      // this.updateCurDeviceId($event.device_id)
      // this.updateCurDeviceName($event.device_name)
      this.updateCurOrg($event.org)
      this.updateCurDep($event.dep)
      this.updateActDep($event.act_dep)
      this.updateCurDest($event.dest)
      this.updateCurArr($event.arr)
      this.updateActArr($event.act_arr)
      this.$router.push({
        name: 'Positions',
        query: {
          train_no:$event.train_no,
          device_id:$event.device_id,
          device_name:$event.device_name
        }
      })
    },
    getFormattedDate(t) {
      if (t) {
        var lt = moment(t).format("YYYY-MM-DD HH:mm:ss")
        var testDateUtc = moment.utc(lt);
        var localDate = moment(testDateUtc).local();
        return localDate.format("DD/MM/YYYY")
      } else {
        return '--'
      }
    },
    getFormattedTime(t) {
      if (t !== '--' && t != null) {
       //  var lt = moment(t).format("YYYY-MM-DD HH:mm:ss")
       //  var testDateUtc = moment.utc(lt);
       // var localDate = moment(testDateUtc).local();
       //  return moment(localDate).format("HH:mm:ss")
       return moment.utc(t).format("HH:mm:ss")
      }
    },
    getFormattedTimeSec(t) {
      if (t < 0) {
        return '-' + moment.utc(Math.abs(t) * 1000).format('HH:mm:ss')
      } else {
        return moment.utc(Math.abs(t) * 1000).format('HH:mm:ss')
      }
    },

    getColour(train) {
      if (train.act_arr) {
        let x = train.late_arr / 60
        switch (true) {
          case (x < 1):
            return 'green'
            break;
          case (x < 5):
            return '#6B8E23'
            break;
          case (x < 11):
            return 'blue'
            break;
          case (x < 21):
            return 'orange'
            break;
          case (x < 31):
            return '#FF1493'
            break;
          case (x < 1000):
            return 'red'
            break;
          default:
            return '#F5DEB3'
            break;
        }
      }
    },
    getSummaryColour(s) {
      return s == "more than 30" ? 'red' :
        s == "21 to 30" ? '#FF1493' :
        s == "11 to 20" ? 'orange' :
        s == "5 to 10" ? 'blue' :
        s == "less than 5" ? '#6B8E23' :
        s == "Right Time" ? 'green' :
        s == "total late" ? '#A52A2A' :
        s == "total train" ? '#D2691E' :
        s == "Puctuality" ? '#8A2BE2' :
        '#F5DEB3'
    },
    getSummary(trains) {
      let summary = {
        "Right Time": 0,
        "less than 5": 0,
        "5 to 10": 0,
        "11 to 20": 0,
        "21 to 30": 0,
        "more than 30": 0,
        "total late": 0,
        "total train": 0,
        "Puctuality": 0
      }
      _.forEach(trains, (train) => {
        if (train.act_arr) {
          let x = train.late_arr / 60
          switch (true) {
            case (x < 1):
              summary["Right Time"]++;
              summary["total train"]++;
              break;
            case (x < 5):
              summary["less than 5"]++;
              summary["Right Time"]++;
              summary["total train"]++;
              break;
            case (x < 11):
              summary["5 to 10"]++;
              summary["total late"]++;
              summary["total train"]++;
              break;
            case (x < 21):
              summary["11 to 20"]++;
              summary["total late"]++;
              summary["total train"]++;
              break;
            case (x < 31):
              summary["21 to 30"]++;
              summary["total late"]++;
              summary["total train"]++;
              break;
            case (x < 1000):
              summary["more than 30"]++;
              summary["total late"]++;
              summary["total train"]++;
              break;
            default:
              break;
          }
        }
      })
      summary["Puctuality"] = Math.round((summary["Right Time"] / summary["total train"]) * 100, 2)
      return summary
    }
  }
}
</script>
